
import { onClickOutside } from '~/directives/onClickOutside';

export default {
  directives: {
    'click-outside': onClickOutside,
  },

  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    link: {
      type: Object,
      default: () => ({}),
    },
    email: {
      type: Object,
      default: () => ({}),
    },
    onChange: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      tab: 1,
      changes: {
        link: {
          url: '',
          title: '',
        },
        email: {
          address: '',
          subject: '',
          title: '',
        },
      },
    };
  },

  mounted() {
    this.changes.link = {
      url: this.link?.url || '',
      title: this.link?.title || '',
    };
    this.changes.email = {
      address: this.email?.address || '',
      subject: this.email?.subject || '',
      title: this.email?.title || '',
    };
    this.tab = this.email?.address || this.email?.subject || this.email?.title ? 2 : 1;
  },

  methods: {
    changeTab(tab) {
      this.tab = tab;
    },

    onInputChange(dataType) {
      if (dataType === 'email') {
        this.changes.link = { url: '', title: '' };
      } else {
        this.changes.email = { address: '', subject: '', title: '' };
      }

      this.onChange(this.changes);
    },
  },
};
